const wrapper = require('wrapper');

// https: //dev.to/ekafyi/lazy-loading-images-with-vanilla-javascript-2fbj
function lazyLoad() {
    const lazyImages = [].slice.call(wrapper.selectAll('img.lazy'));
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver(((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove('lazy');
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        }));

        // Loop through and observe each image
        lazyImages.forEach((lazyImage) => {
            lazyImageObserver.observe(lazyImage);
        });
    }
    else {
        lazyImages.forEach((lazyImage) => {
            /* eslint-disable no-param-reassign */
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove('lazy');
        });
    }
}

module.exports = lazyLoad;
